import { config } from "common/config";

let timer: NodeJS.Timeout;

export const inactivityTimeOut = (timeOutFn: () => void, timeoutValue: number = config.inactivityTimeout) => {
    if (timer) {
        clearTimeout(timer);
    }
    timer = setTimeout(() => {
        if (timeOutFn) {
            timeOutFn();
        }
    }, timeoutValue);
};
